import FAQsModule from './FAQsModule';

export * from './FAQsModule';
export default FAQsModule;
